import { graphql } from 'gql'

export const GET_YIELDBIRD_DEMAND_REPORT = graphql(`
  query getYieldbirdDemandReport($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        ...YieldbirdDemandReport
      }
    }
  }
`)
